import React, { useState, useEffect, useRef } from 'react';

import { Link } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {logout, selectUser} from '@/features/auth/model/authSlice'; // путь скорректируй под проект

export const Header: React.FC = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const user = useSelector(selectUser); // ← получаем пользователя из Redux
    const sidebarRef = useRef<HTMLDivElement>(null);

    const toggleSidebar = () => setSidebarOpen(prev => !prev);
    const closeSidebar = () => setSidebarOpen(false);

    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(logout());
        window.location.href = '/'; // или navigate('/'), если используешь useNavigate()
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target as Node)
            ) {
                setSidebarOpen(false);
            }
        };

        const handleEscKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                setSidebarOpen(false);
            }
        };

        if (isSidebarOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('keydown', handleEscKey);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [isSidebarOpen]);

    return (
        <>
            <header className="header">
                <div className="container">
                    <div className="header__inner">
                        <div className="header__left">
                            <Link to="/" className="logo header__logo">
                                <img src="/img/logo.svg" alt="Bionmax" />
                            </Link>

                            <nav className="nav header__nav">
                                <ul className="nav__list">
                                    <li className="nav__item">
                                        <Link to="/" className="nav__link header__link">Главная</Link>
                                    </li>
                                    <li className="nav__item">
                                        <Link to="/checkup" className="nav__link header__link">Мое здоровье</Link>
                                    </li>
                                    <li className="nav__item">
                                        <Link to="/contacts" className="nav__link header__link">Контакты</Link>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                        <div className="header__right">
                            {user ? (
                                <div className="header__account" >
                                    <Link to="/account" className="account-link" style={{display: 'flex', alignItems: 'center'}}>
                                        <img src='/img/profile-avatar.jpg' alt="avatar" className="account-link__avatar" />
                                        <span className="account-link__text">Мой Аккаунт</span>
                                    </Link>
                                </div>
                            ) : (
                                <div className="header__account">
                                    <Link to="/login" className="button">Войти</Link>
                                </div>
                            )}

                            <div className="header__sidebar-toggle" onClick={toggleSidebar}>
                                <svg className="svg-icon">
                                    <use href="/img/sprite-icons.svg#menu"></use>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Sidebar */}
            <aside  onClick={closeSidebar} className={`sidebar sidebar_desktop ${isSidebarOpen ? '_active' : ''}`} data-sidebar="desktop">
                {isSidebarOpen && (
                    <div className="sidebar__overlay" onClick={closeSidebar}></div>
                )}
                <div className="sidebar__content" ref={sidebarRef}>
                <div className="sidebar__menu-outer">
                            <div className="sidebar__menu-inner">
                                <div className="sidebar__menu sidebar-menu">
                                    <header className="sidebar-menu__header">
                                        <h5 className="title sidebar-menu__title">Меню</h5>
                                        <div onClick={closeSidebar} className="close-button sidebar__close-button sidebar-menu__close-button">
                                            <svg className="svg-icon">
                                                <use
                                                    href="/img/sprite-icons.svg#cross"></use>
                                            </svg>
                                        </div>
                                    </header>

                                    <div className="sidebar-menu__content">
                                        <nav className="sidebar-menu__nav&quot;">
                                            <ul id="menu-sidebar" className="sidebar-menu__list">
                                                <li id="menu-item-175"
                                                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-175 sidebar-menu__item">
                                                    <Link to="/account"
                                                       className="sidebar-menu__link">Личный кабинет</Link></li>
                                                <li id="menu-item-691"
                                                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-691 sidebar-menu__item">
                                                    <Link to="/"
                                                       className="sidebar-menu__link">Главная</Link></li>
                                                <li id="menu-item-174"
                                                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-174 sidebar-menu__item">
                                                    <Link to="/checkup"
                                                          className="sidebar-menu__link">Мое здоровье</Link></li>
                                                <li id="menu-item-179"
                                                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-179 sidebar-menu__item">
                                                    <Link to="/contacts"
                                                          className="sidebar-menu__link">Контакты</Link></li>

                                            </ul>
                                        </nav>
                                        <div className="social-links sidebar-menu__social-links">
                                            <a className="social-links__link" href=""
                                               target="_blank">
                                                <svg className="svg-icon">
                                                    <use
                                                        href="/img/sprite-icons.svg#telegram"></use>
                                                </svg>
                                            </a>
                                            <a className="social-links__link" href=""
                                               target="_blank">
                                                <svg className="svg-icon">
                                                    <use
                                                        href="/img/sprite-icons.svg#vk"></use>
                                                </svg>
                                            </a>
                                            <a className="social-links__link" href=""
                                               target="_blank">
                                                <svg className="svg-icon">
                                                    <use
                                                        href="/img/sprite-icons.svg#youtube"></use>
                                                </svg>
                                            </a>
                                        </div>
                                        {user ? (
                                            <div className="sidebar-menu__account">
                                                <div className="sidebar-menu__account-button">
                                                    <button className="button" onClick={handleLogout}>
                                                        Выйти
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                        <div className="sidebar-app-buttons">
                                            <div className="app-buttons-wrapper">
                                                <h4>Скачайте BionMax на смартфон</h4>
                                                <div className="app-buttons">
                                                    <a href=""
                                                       className="app-button">
                                                        <span>Телеграм</span>
                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_9069_32234)">
                                                                <path d="M7.06264 11.3861L6.76489 15.5741C7.19089 15.5741 7.37539 15.3911 7.59664 15.1713L9.59389 13.2626L13.7324 16.2933C14.4914 16.7163 15.0261 16.4936 15.2309 15.5951L17.9474 2.86605L17.9481 2.8653C18.1889 1.7433 17.5424 1.30455 16.8029 1.5798L0.835389 7.69305C-0.254361 8.11605 -0.237861 8.72355 0.650139 8.9988L4.73239 10.2686L14.2146 4.3353C14.6609 4.0398 15.0666 4.2033 14.7329 4.4988L7.06264 11.3861Z" fill="#0E4F69"/>
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_9069_32234">
                                                                    <rect width="18" height="18" fill="white"/>
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </a>
                                                    <a href="/ios" className="app-button">
                                                        <span>Установить на iOS</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                                             viewBox="0 0 22 22" fill="none">
                                                            <path
                                                                d="M15.2336 0C15.2848 0 15.336 0 15.3901 0C15.5157 1.55149 14.9235 2.71075 14.2038 3.55026C13.4976 4.38396 12.5306 5.19255 10.9665 5.06986C10.8622 3.5406 11.4554 2.46731 12.1741 1.62974C12.8407 0.849163 14.0628 0.154569 15.2336 0Z"
                                                                fill="#404040"></path>
                                                            <path
                                                                d="M19.9683 16.1482C19.9683 16.1636 19.9683 16.1772 19.9683 16.1917C19.5287 17.5229 18.9017 18.6638 18.1366 19.7226C17.4382 20.6838 16.5822 21.9774 15.0539 21.9774C13.7333 21.9774 12.8562 21.1282 11.5027 21.105C10.071 21.0818 9.28369 21.8151 7.97468 21.9996C7.82494 21.9996 7.67521 21.9996 7.52837 21.9996C6.56714 21.8605 5.7914 21.0992 5.22625 20.4133C3.55981 18.3865 2.27205 15.7685 2.03247 12.4182C2.03247 12.0898 2.03247 11.7623 2.03247 11.4338C2.13391 9.03608 3.29897 7.08658 4.84756 6.14178C5.66484 5.63943 6.78837 5.21147 8.03941 5.40274C8.57557 5.48583 9.12332 5.66938 9.60345 5.85099C10.0585 6.02585 10.6275 6.33595 11.1665 6.31953C11.5317 6.30891 11.8949 6.11859 12.263 5.98431C13.3411 5.59499 14.398 5.14867 15.791 5.35831C17.4652 5.61141 18.6535 6.35528 19.3877 7.50295C17.9714 8.40428 16.8518 9.76256 17.0431 12.0821C17.2131 14.189 18.438 15.4217 19.9683 16.1482Z"
                                                                fill="#404040"></path>
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </aside>
        </>
    );
};
